export default __webpack_public_path__ + "static/char-s-57-zh-Hans-acc4728985a4b04c93f9668c41f0580f.png";